import React from "react";

/* Import Boostrap */
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

class GenericParagraph extends React.Component { 
    constructor(props) {
        super(props);
        this.state = { 
            class : 'animate-box' 
        }
    }
    componentDidMount = () => {
        var that = this;
        setTimeout(function() {
            that.show();
        }, that.props.wait);
    } 
    show = () => {
        this.setState({class : this.props.className});
    }       
    render () {
        return (
            <p className={this.state.class}>{ this.props.translate(this.props.text) }</p>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(GenericParagraph);



// WEBPACK FOOTER //
// ./src/components/paragraphs/Paragraph.jsx